import RichTextCopy from '@/components/shared/RichTextCopy/RichTextCopy';
import { cn } from '@/utils/styles';
import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { AuthorProps } from '../types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export type BlogAuthorProps = AuthorProps & {
  byLinePrefix?: string;
  className?: string;
};

const BlogAuthor = ({ name, title, image, bio, slug, sys, byLinePrefix, className }: BlogAuthorProps) => {
  const authorPageHref = slug ? (slug.startsWith('/') ? slug : `/${slug}`) : undefined;

  const photo = image && (
    <div className="h-12 w-12 rounded-full">
      <Media media={image} className="object-cover rounded-full h-full" />
    </div>
  );

  return (
    <div className={cn({ 'grid grid-cols-[auto_1fr] gap-4 items-start': image }, className)}>
      {image &&
        (authorPageHref ? (
          <Link href={authorPageHref} aria-label={name}>
            {photo}
          </Link>
        ) : (
          photo
        ))}

      <div className="font-sans items-center">
        <p className="text-label-saans font-[670]" {...liveUpdateAttrs(sys?.id, 'name')}>
          {byLinePrefix && <span className="text-content-secondary">{byLinePrefix} </span>}
          {authorPageHref ? (
            <Link
              className="hover:underline hover:text-(--richtext-link-hover) focus:text-(--richtext-link-hover)"
              href={authorPageHref}>
              {name}
            </Link>
          ) : (
            name
          )}
        </p>
        {title && (
          <p className="pt-1 text-content-secondary font-[570] leading-[1.2]" {...liveUpdateAttrs(sys?.id, 'title')}>
            {title}
          </p>
        )}
        {bio && (
          <div className="py-2 text-content-primary leading-[1.4]">
            <RichTextCopy copy={bio} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogAuthor;
